import { z } from 'zod';

/** Empty strings from forms break Mongoose ObjectId/Date casts — omit them before persist. */
function stripEmptyOptionalFields(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
    const out = { ...data };
    const optionalKeys = ['owner', 'team', 'vendor', 'startDate', 'endDate', 'description', 'step', 'timeframe', 'dependencies'];
    for (const key of optionalKeys) {
        if (out[key] === '' || out[key] === null) {
            delete out[key];
        }
    }
    return out;
}

export const CrisisRecoveryActivitySchema = z.object({
    id: z.string().optional(),
    step: z.number().optional(),
    name: z.string().min(1),
    description: z.string().optional(),
    timeframe: z.string().optional(),
    dependencies: z.string().optional(),
    owner: z.string().optional(),
    team: z.string().optional(),
    startDate: z.string().optional().or(z.date().optional()),
    endDate: z.string().optional().or(z.date().optional()),
    progress: z.coerce.number().min(0).max(100).optional(),
    externalSupport: z.boolean().optional(),
    vendor: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateCrisisRecoveryActivitySchema = z.preprocess(
    stripEmptyOptionalFields,
    CrisisRecoveryActivitySchema.omit({ id: true })
);

export const UpdateCrisisRecoveryActivitySchema = z.preprocess(
    stripEmptyOptionalFields,
    CrisisRecoveryActivitySchema.partial()
);
